import { ConfirmModal } from '@/shared/ui/components';
import { DEVICE } from '@/shared/config';
import _ from 'lodash';
import { t } from 'ttag';
import type { DisclaimerModalProps } from './disclaimerModal.types';
import './disclaimerModal.scss';
import { STUDY_STATUS } from '../../lib/studyConstants';

const EMPTY_OBJECT = {};

const DisclaimerModal = ({
  isOpen,
  leftButtonName = '',
  onClickLeftButton,
  rightButtonName = '',
  isFilledRightButton = false,
  onClickRightButton,
  study = EMPTY_OBJECT,
}: DisclaimerModalProps) => {
  /**
   * Renders the study's reference code inline in the disclaimer text when the patient is still allowed to see it. Hides the code for aborted studies and for statuses that end visibility (DONE, plus COMPLETED on Bioflux devices), and falls back to a single space when there is no study or no code.
   *
   * @returns Reference code span, or a blank space.
   */
  const displayRefCode = () => {
    if (!_.isEmpty(study)) {
      const canNotViewReferenceCodeStudyStatus =
        study.device?.model === DEVICE.BIOFLUX
          ? [STUDY_STATUS.COMPLETED, STUDY_STATUS.DONE]
          : [STUDY_STATUS.DONE];
      const isShowRefCode =
        !_.includes(canNotViewReferenceCodeStudyStatus, study.status) &&
        study.status !== STUDY_STATUS.ABORTED;
      if (isShowRefCode && study.referenceCode) {
        return <span className="ref-code">{` ${study.referenceCode} `}</span>;
      }
    }
    return ' ';
  };

  return (
    <ConfirmModal
      className="warning-modal disclaimer-modal"
      isRedBtn={false}
      isOpen={isOpen}
      title={t`Disclaimer`}
      customContent={
        <div>
          <div>
            {t`For MCT and Event studies, the patient must be instructed of the importance of maintaining a Biocore to Biocare Health app connection.`}
          </div>
          <div className="mt1">
            {t`Please ensure the reference code`}
            {displayRefCode()}
            {t`is entered on the mobile device to connect their Biocore device to the Biocare Health app and maintain the connection during the study.`}
          </div>
          <div className="mt1">
            {t`Please note that study response times may be affected if the connection is not ensured.`}
          </div>
        </div>
      }
      leftButtonName={leftButtonName}
      onClickLeftButton={onClickLeftButton}
      rightButtonName={rightButtonName}
      isFilledRightButton={isFilledRightButton}
      onClickRightButton={onClickRightButton}
    />
  );
};

export default DisclaimerModal;
